import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

import { getSfmlData } from "../../actions";

import SFML from "./component";

export interface SFMLProps {
  flyerItemsLoading: boolean;
  sfmlErrorMessage: string | null;
  sfmlData: any;
  store: any;
  fullscreen: boolean;
}

export interface SFMLActions {
  getSfmlData: () => void;
}

const mapStateToProps = (state: any, props: any): SFMLProps => {
  return {
    flyerItemsLoading: state.analytics_metric.flyer_items_loading,
    sfmlErrorMessage: state.analytics_metric.sfmlErrorMessage,
    sfmlData: state.analytics_metric.sfmlData,
    store: state,
    fullscreen: props.fullscreen
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>): SFMLActions => {
  return {
    ...bindActionCreators(
      {
        getSfmlData
      },
      dispatch
    )
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SFML));



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/SFML/container.ts